/**
 * Fetch state of the subject area Count or percent toggle
 * @param state
 * @returns
 */
export const fetchToggleState = (state: RootState): boolean => {
	return state.subjectAreaAttainmentProfile.showStudentCount;
};

/**
 * Fetch the stored Comparison Gradepoint
 * @param state
 * @returns
 */
export const fetchComparisonGradepoint = (state: RootState): string => {
	return state.subjectAreaAttainmentProfile.comparisonGradepoint;
};

/**
 * Fetch Error messages for Attainment Grid
 * @param state
 * @returns
 */
export const fetchGridError = (state: RootState): string => {
	return state.subjectAreaAttainmentProfile.gridError;
};

/**
 * Fetch Error messages for Attainment Graph
 * @param state
 * @returns
 */
export const fetchGraphError = (state: RootState): string => {
	return state.subjectAreaAttainmentProfile.graphError;
};

/**
 * Fetch the state of the saga flow - TODO: consider if this is a subject attainment thing or a subject page thing
 * @param state
 * @returns
 */
export const fetchSagaStatus = (state: RootState): boolean => {
	return state.subjectAreaAttainmentProfile.overallSagaFailure;
};

/**
 * Whether attainment profile data is currently being fetched.
 * Owned entirely by the fetchAttainmentProfileData saga — set true when the
 * request starts, false when it resolves or errors.
 */
export const fetchAttainmentLoading = (state: RootState): boolean => {
	return state.subjectAreaAttainmentProfile.loading;
};
